/**
 * @Description: 渠道的数据统计组件
 * @author Shi_qshan
 * @date 2021/7/26
 */
import React from "react";
import QuestionTip from "../questionTip";

/**
 *
 * @param props 数组名传 dataArray ！！
 * @returns {JSX.Element}
 * @constructor
 */
const ZkStatistics = ({title: title, tooltip: tooltip, value: value, vUnit: vUnit, footer: footer}) => {

    return (
        <ul className={'zkStatistics'}>
            <li className='zkStatisticsTitle'>
                {title}
                {
                    tooltip ? <QuestionTip title={tooltip}/> : ''
                }
            </li>
            <li className='zkStatisticsVal'>
                {value}
                <span>{vUnit}</span>
            </li>
            {
                footer ? <ul className='zkStatisticsFooter'>
                    {
                        footer.map((item, index) => {
                            //如果穿过来的 footer 为空对象，让他 占位且不显示
                            if(JSON.stringify(item) == "{}"){
                                return <li style={{visibility:'hidden'}} key={'footer' + '空'}>空</li>
                            }else {
                                return  <li key={'footer' + index}>
                                    {item.title}：{item.value}
                                    <span>{item.vUnit}</span>
                                </li>
                            }
                            }
                        )
                    }
                </ul> : ''
            }

        </ul>
    )
};

export default ZkStatistics